import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText, type = 'default' }) => {
  if (!isOpen) return null;

  const getTypeConfig = () => {
    switch (type) {
      case 'warning':
        return {
          icon: 'AlertTriangle',
          iconBg: 'bg-warning/10',
          iconColor: 'text-warning',
          confirmVariant: 'warning'
        };
      case 'danger':
        return {
          icon: 'AlertCircle',
          iconBg: 'bg-error/10',
          iconColor: 'text-error',
          confirmVariant: 'destructive'
        };
      default:
        return {
          icon: 'Info',
          iconBg: 'bg-primary/10',
          iconColor: 'text-primary',
          confirmVariant: 'default'
        };
    }
  };

  const config = getTypeConfig();

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card rounded-lg border border-border max-w-md w-full shadow-elevation-xl">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className={`w-12 h-12 rounded-lg ${config?.iconBg} flex items-center justify-center flex-shrink-0`}>
              <Icon name={config?.icon} size={24} className={config?.iconColor} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {message}
              </p>
            </div>
          </div>
        </div>

        <div className="px-6 py-4 bg-muted border-t border-border flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 sm:flex-initial"
          >
            Cancel
          </Button>
          <Button
            variant={config?.confirmVariant}
            onClick={onConfirm}
            className="flex-1 sm:flex-initial"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;